import { createApp, provide } from 'vue';
import { createPinia } from 'pinia';
import _ from 'lodash';
import CbpPaymentApp from './vue/cbp-payment-app/app.vue';

function InitCbpPayment(options) {
    const pinia = createPinia();
    const app = createApp(CbpPaymentApp);
    app.use(pinia);
    _.forEach(options, (value, key) => app.provide(key, value));

    app.mount('#CbpPaymentApp');
}

export { InitCbpPayment }